import { Module } from 'vuex';
import { state, ProyectoState } from './state';
import { mutations } from './mutations';
import actions from './actions';
import { getters } from './getters';

const proyectosVivienda: Module<ProyectoState, any> = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};


export default proyectosVivienda;